import moment from "moment/moment";
import { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PaginationLinks from "./../pagination/PaginationLinks";
import {
  getAccounts,
  getFiltered,
  getRelatedTransactions,
  resetChartOfAccountStatus,
  resetJournals,
  reverseTransaction,
} from "./../../redux/slice/accounting/accountingSlice";
import { useRef } from "react";
import { closeDialog, showDialog } from "../../utils/helpers/toggleTheme";
import ModalOne from "../modals/custom/ModalOne";
import Reversal from "../modals/accounting/Reversal";

const JournalTable = ({ data }) => {
  const [hasViewJournal, setHasViewJournal] = useState();
  const [hasReverseJournal, setHasReverseJournal] = useState();
  const { isUpdated, journals } = useSelector((state) => state?.accounting);
  const { related_transactions, isLoading, isReversed } = useSelector(
    (state) => state?.accounting
  );
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [viewJournal, setViewJournal] = useState(null);

  //Used along with ModalOne
  /**start **/
  const [showModal, setShowModal] = useState(false);

  // const form = useRef();

  const handleClose = (form) => {
    setShowModal(false);
    closeDialog();
    // form.current.reset();
  };
  /**end **/

  const fetchJournals = useCallback(async (pageNumber) => {
    setPageNumber(pageNumber);
    dispatch(getFiltered({ data, pageNumber }));
  });

  useEffect(() => {
    if (isReversed) {
      handleClose();
      dispatch(resetChartOfAccountStatus());
    }
  }, [isReversed]);

  useEffect(() => {
    setHasViewJournal(
      user_permissions?.some(
        (permission) => permission.name === "view journal entry details"
      )
    );
    setHasReverseJournal(
      user_permissions?.some(
        (permission) => permission.name === "reverse journal entry transaction"
      )
    );
  }, [user_permissions]);

  // modal footer with buttons for cancel and reverse transactions
  const footer = (
    <>
      {related_transactions && (
        <div className='modal__footer'>
          <div className='d-flex justify-content-end me-2'>
            {hasReverseJournal && (
              <div>
                {viewJournal?.reversed !== 1 &&
                viewJournal?.manual_entry === "Yes" ? (
                  <button
                    className='btn btn-sm btn-primary me-2'
                    // onClick={() => dispatch(reverseTransaction({}))}
                    onClick={() => {
                      let ReversalValue = related_transactions?.journal?.reduce(
                        (acc, currentValue) => {
                          if (currentValue?.transaction_type === 2) {
                            var debit = {
                              d_account_id: currentValue?.account_id,
                              d_amount: currentValue?.amount,
                              d_office_id: currentValue?.office_id,
                            };
                          } else {
                            var credit = {
                              c_account_id: currentValue?.account_id,
                              c_amount: currentValue?.amount,
                              c_office_id: currentValue?.office_id,
                            };
                          }
                          currentValue?.transaction_type === 2
                            ? acc.debit_arrays.push(debit)
                            : acc.credit_arrays.push(credit);
                          return acc;
                        },
                        { debit_arrays: [], credit_arrays: [] }
                      );
                      dispatch(
                        reverseTransaction({
                          ...ReversalValue,
                          transaction_id: viewJournal?.transaction_id,
                        })
                      );
                    }}
                  >
                    Reverse Transaction
                  </button>
                ) : null}
              </div>
            )}
            <button className='btn btn-sm btn-secondary' onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );

  return (
    <>
      <div className=''>
        {journals?.journal?.data?.length < 1 && (
          <div>
            <h5 className='alert alert-info p-2'>No results found!</h5>
          </div>
        )}
        <div className='table-responsive mt- '>
          {journals?.journal?.data?.length ? (
            <>
              <div className='d-flex justify-content-end'>
                <div
                  className='d-flex bg-primary-1 align-items-center '
                  style={{ height: "30px" }}
                >
                  <input
                    type='text'
                    className='border-0'
                    placeholder='Search...'
                    style={{
                      height: "28px",
                      marginLeft: "1px",
                      outline: "none",
                    }}
                  />
                  <button
                    type='button'
                    className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                    style={{ height: "28px" }}
                  >
                    <i className='uil uil-search text-white fs-4'></i>
                  </button>
                </div>
              </div>
              <table className='table table-centered table-striped no-footer'>
                <thead>
                  <tr>
                    <th
                      className='sorting'
                      tabIndex='0'
                      rowSpan='1'
                      colSpan='1'
                      style={{ width: "120.8px" }}
                      aria-label='Customer: activate to sort column ascending'
                    >
                      Transaction ID
                    </th>
                    <th
                      className='sorting'
                      tabIndex='0'
                      rowSpan='1'
                      colSpan='1'
                      style={{ width: "144.8px" }}
                      aria-label='Phone: activate to sort column ascending'
                    >
                      Transaction Type
                    </th>
                    <th
                      className='sorting'
                      tabIndex='0'
                      rowSpan='1'
                      colSpan='1'
                      style={{ width: "100.8px" }}
                      aria-label='Email: activate to sort column ascending'
                    >
                      Date Effective
                    </th>
                    <th
                      className='sorting'
                      tabIndex='0'
                      rowSpan='1'
                      colSpan='1'
                      style={{ width: "100.8px" }}
                      aria-label='Location: activate to sort column ascending'
                    >
                      Branch
                    </th>
                    <th
                      className='sorting'
                      tabIndex='0'
                      rowSpan='1'
                      colSpan='1'
                      style={{ width: "100.8px" }}
                      aria-label='Location: activate to sort column ascending'
                    >
                      GL Code
                    </th>
                    <th
                      className='sorting'
                      tabIndex='0'
                      rowSpan='1'
                      colSpan='1'
                      style={{ width: "100.8px" }}
                      aria-label='Location: activate to sort column ascending'
                    >
                      GL Account
                    </th>
                    <th
                      className='sorting'
                      tabIndex='0'
                      rowSpan='1'
                      colSpan='1'
                      style={{ width: "100.8px" }}
                      aria-label='Status: activate to sort column ascending'
                    >
                      debit
                    </th>
                    <th
                      className='sorting'
                      tabIndex='0'
                      rowSpan='1'
                      colSpan='1'
                      style={{ width: "100.8px" }}
                      aria-label='Status: activate to sort column ascending'
                    >
                      credit
                    </th>
                    <th style={{ width: "85.8px" }} className='text-center'>
                      Balance
                    </th>
                    <th style={{ width: "85.8px" }} className='text-center'>
                      reference
                    </th>
                  </tr>
                </thead>

                <>
                  <tbody>
                    {journals?.journal?.data?.map((item, i) => (
                      <tr key={i}>
                        <td className='text-capitalize'>
                          {item?.transaction_id}
                        </td>
                        <td>
                          {/* {item?.manual_entry === "Yes" ? "Manual Entry" : ""} */}
                          {item?.transaction_type !== 3
                            ? item?.manual_entry === "Yes"
                              ? "Manual Entry"
                              : "Automatic"
                            : "Migrated"}
                        </td>
                        <td>{moment(item?.entry_date).format("D-M-Y")}</td>
                        <td>{item?.office_name}</td>
                        <td>{item?.gl_code}</td>
                        <td>{item?.account_name}</td>
                        <td className='text-center'>
                          {item?.transaction_type === 2 ? item?.amount : "-"}
                        </td>
                        <td className='text-center'>
                          {item?.transaction_type === 1 ? item?.amount : "-"}
                        </td>
                        <td className='text-center'>{item?.balance}</td>
                        <td className='text-center'>-</td>
                        {hasViewJournal && (
                          <td className='text-center'>
                            <i
                              className='mdi mdi-eye'
                              title='view journal'
                              onClick={() => {
                                setShowModal(true);
                                showDialog();
                                setViewJournal(item);
                              }}
                            ></i>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </>
              </table>
            </>
          ) : (
            ""
          )}
        </div>

        {journals?.journal?.data?.length ? (
          <div className='row mt-4'>
            <div className='col-sm-12 col-md-6'>
              <div
                className='dataTables_info table-pages'
                id='products-datatable_info'
                role='status'
                aria-live='polite'
              >
                Showing offices {journals?.journal?.from} to{" "}
                {journals?.journal?.to} of {journals?.journal?.total}
              </div>
            </div>

            <div className='col-sm-12 col-md-6'>
              <PaginationLinks
                paginationData={journals?.journal}
                getNextPage={fetchJournals}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      <ModalOne
        showModal={showModal}
        handleClose={handleClose}
        footer={footer}
        title='View Journal Entry'
        maxWidth={"650px"}
        maxHeight={isLoading && "150px"}
      >
        <Reversal
          handleClose={handleClose}
          showModal={showModal}
          transaction_id={viewJournal?.transaction_id}
          data={viewJournal}
        />
      </ModalOne>
    </>
  );
};

export default JournalTable;
